// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BlankLayout_wrapper__2JIOd"};